import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import { getTranslation } from "../../translations/getTranslations";
import { deleteUserById } from "../../services/userService";
import { logoutAndClearData } from "../../redux/slices/authSlice";
import { useNotification } from "../../notifications/Notifications";

const DeleteUserModal = ({ showModal, onClose, currentUsername }) => {
  const [enteredUsername, setEnteredUsername] = useState("");
  const userId = useSelector(state => state.auth.user.userId);
  const language = useSelector(state => state.settings.language);

  const translation = key => getTranslation("deleteUserModal", key, language);
  const dispatch = useDispatch();
  const notify = useNotification();

  useEffect(() => {
    setEnteredUsername("");
  }, [showModal]);

  const handleDeleteSubmit = async () => {
    if (enteredUsername !== currentUsername) {
      notify("error", translation("_usernameMismatch"));
      return;
    }

    try {
      await deleteUserById(userId);
      onClose();
      dispatch(logoutAndClearData());
    } catch (error) {
      notify("error", translation("_deleteFailed"));
    }
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-[1100] flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div
        className={`relative w-[450px] rounded bg-backgroundPrimary p-6 text-center text-lg text-textPrimary shadow-lg`}
      >
        <button
          className={`absolute right-1 top-0 p-2 text-xl text-buttonCancel hover:text-buttonCancelHover`}
          onClick={onClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <h2 className="mb-6 text-lg font-semibold">{translation("_confirmDeleteUser")}</h2>
        <input
          type="text"
          className={`w-full rounded border border-inputBorder bg-inputBackground p-3 text-textPrimary hover:bg-inputHover focus:outline-none`}
          placeholder={translation("_enterUsernameToDelete")}
          value={enteredUsername}
          onChange={e => setEnteredUsername(e.target.value)}
        />
        <p className="my-2 h-5 text-sm text-red-500">{}</p>
        <button
          className={`w-full cursor-pointer rounded bg-buttonSubmit p-3 text-base text-buttonText hover:bg-buttonSubmitHover`}
          onClick={handleDeleteSubmit}
        >
          {translation("_confirm")}
        </button>
      </div>
    </div>
  );
};

export default DeleteUserModal;
